import { MetricConfig, TaskMetric } from './types/analytics.type';

export const METRIC_CONFIGS: MetricConfig[] = [
  { key: TaskMetric.TOTAL, label: 'Total Tasks' },
  { key: TaskMetric.COMPLETED, label: 'Completed Tasks' },
  { key: TaskMetric.PENDING_TASK, label: 'Pending Tasks', tooltip: 'The number of tasks that are yet to be completed. Calculated as Total Tasks - Completed Tasks.' },
  { key: TaskMetric.ACTIVE, label: 'Active Tasks' },
  {
    key: TaskMetric.ACCEPTED_AS_IS,
    label: 'Accepted As-Is %',
    suffix: '%',
    valueColor: '#15803D',
    tooltip: 'Percentage of reviewed tasks accepted without edits.',
  },
  {
    key: TaskMetric.ACCEPTED_WITH_EDITS,
    label: 'Accepted With Edits %',
    suffix: '%',
    valueColor: '#B45309',
    tooltip: 'Percentage of reviewed tasks accepted after edits.',
  },
  {
    key: TaskMetric.QUALITY_REJECTED,
    label: 'Rejected %',
    suffix: '%',
    valueColor: '#B91C1C',
    tooltip: 'Percentage of reviewed tasks rejected. Rejected count is cumulative and should persist after rework.',
  },
  { key: TaskMetric.AWAITING_REVIEW, label: 'Awaiting Review' },
  { key: TaskMetric.NOT_STARTED, label: 'Not Started' },
  { key: TaskMetric.AHT, label: 'Average Handle Time', suffix: 'h' },
  { key: TaskMetric.COMPLETION, label: 'Completion Rate', suffix: '%' }
];